// src/data/properties.js

export const properties = [
  {
    id: 1,
    priceTag: "Best Offer",
    title: "Luxury 3 Bedroom Sea View Apartment",
    location: "Lekki Phase 1, Lagos",
    price: 250000,
    rating: 4.9,
    images: [
      "https://bookingenginecdn.hostaway.com/listing/116833-416462-wJIZTyCA5EPoYWyiar3qmSiuZ--qHzK6SB-R4pVqIUlc-688b4d75c357f?width=1080&quality=70&format=webp&v=2",
      "https://bookingenginecdn.hostaway.com/listing/116833-416462-Xmj05d-2mGk8kjdleFdZ8aGABFOiNv2HjpvUoVfkDi4-688b546fdc2fb?width=640&quality=70&format=webp&v=2",
      "https://bookingenginecdn.hostaway.com/listing/116833-409723---W5g8nYqflEsGIJDFt7v49Ha7kLQOW0QKOiWPJyZG4A-68686b921abfc?width=640&quality=70&format=webp&v=2",
      "https://bookingenginecdn.hostaway.com/listing/116833-416462-R2XN3tQ3S4M---iupD2seC4Qu2rX--Nov8j3T6Zl1YYpw-688b4d71d738c?width=640&quality=70&format=webp&v=2",
    ],
    bedrooms: 3,
    bathrooms: 3,
    guests: 6,
    amenities: ["Pool", "WiFi", "Air Conditioning", "Kitchen"],
    type: "Apartment",
    description:
      "Experience luxury living in this stunning 3-bedroom apartment with panoramic ocean views, modern finishing, and premium amenities.",
  },

  {
    id: 2,
    title: "Modern 4 Bedroom Duplex",
    location: "Chevron Drive, Lekki",
    price: 180000,
    rating: 4.7,
    images: [
      "https://bookingenginecdn.hostaway.com/listing/116833-407457-SSS-5oTnjjxbR--ghB1djraiI64JmKWVCY4xy7TRKTYA-685ff9094b7a5?width=1080&quality=70&format=webp&v=2",
      "https://bookingenginecdn.hostaway.com/listing/116833-407457-659yQ--ZqqcZBMTLdlvgVfp1Q--oEl-ePp--1r8Nc75VlE-68606a80a90b6?width=640&quality=70&format=webp&v=2",
      "https://bookingenginecdn.hostaway.com/listing/116833-407457-6hAx-lBY5ADrSQtp82-1ARBHew7z3STr4hkzyfpdrSw-685ff905bc774?width=640&quality=70&format=webp&v=2",
    ],
    bedrooms: 4,
    bathrooms: 4,
    guests: 8,
    amenities: ["Parking", "Kitchen", "Air Conditioning", "24/7 Security"],
    type: "Duplex",
    description:
      "A spacious and stylish duplex situated in a serene neighborhood with excellent security and modern convenience.",
  },

  {
    id: 3,
    title: "Elegant 2 Bedroom Shortlet Apartment",
    location: "Victoria Island, Lagos",
    price: 130000,
    rating: 4.8,
    images: [
      "https://bookingenginecdn.hostaway.com/listing/116833-409723-3IN0XoPirk5vlJOmJ21AFV24B6yJesJMAbWW2LIMD8c-68686b93c9dc8?width=1080&quality=70&format=webp&v=2",
      "https://bookingenginecdn.hostaway.com/listing/116833-409723-BY0J4Epij6gDsDS1vhHnxQVbmqp3RtT8yMU3qxHAI7Y-6868def9295ab?width=640&quality=70&format=webp&v=2",
      "https://bookingenginecdn.hostaway.com/listing/116833-409723-7MF--nz-g023E1LBe5pKkAn0MsUV7ofV7OKgumveO1jU-6868def817752?width=640&quality=70&format=webp&v=2",
      "https://bookingenginecdn.hostaway.com/listing/116833-409723---W5g8nYqflEsGIJDFt7v49Ha7kLQOW0QKOiWPJyZG4A-68686b921abfc?width=640&quality=70&format=webp&v=2"
    ],
    bedrooms: 2,
    bathrooms: 2,
    guests: 4,
    amenities: ["WiFi", "Smart TV", "Air Conditioning"],
    type: "Apartment",
    description:
      "This cozy apartment offers comfort and convenience with a clean layout and city views in the heart of Victoria Island.",
  },

  {
    id: 4,
    title: "Luxury Penthouse With Private Pool",
    location: "Ikoyi, Lagos",
    price: 450000,
    rating: 5.0,
    images: [
      "https://bookingenginecdn.hostaway.com/listing/116833-424944-sD08wL-uayAuTrkpLN8zKHpL0u2NPDfYlghXMjwJ6W4-68a5ea9e1dc88?width=1080&quality=70&format=webp&v=2",
      "https://bookingenginecdn.hostaway.com/listing/116833-424944-qHBRGn5p9AfD4uJrNGPPpbshDcpRQHKepnK00034lCg-68a5ea9cc48d9?width=640&quality=70&format=webp&v=2",
      "https://bookingenginecdn.hostaway.com/listing/116833-424944-xm-cMWoFEd-IuandrVssQJ7DLUwIs9a30mzSmyfrXUY-68a5ea9ab2383?width=640&quality=70&format=webp&v=2",
      "https://bookingenginecdn.hostaway.com/listing/116833-424944-iHiliWlfVmKOO4EZ3wOu2uORjGdhWpm-dDSeDt31Ksg-68a5ea99921a3?width=640&quality=70&format=webp&v=2"
    ],
    bedrooms: 4,
    bathrooms: 5,
    guests: 8,
    amenities: ["Private Pool", "Gym", "Chef Service", "Luxury Finish"],
    type: "Penthouse",
    description:
      "A world-class penthouse featuring a private rooftop pool, top-tier interior design, and breathtaking skyline views.",
  },

  {
    id: 5,
    title: "Stylish 1 Bedroom Studio Apartment",
    location: "Yaba, Lagos",
    price: 55000,
    rating: 4.5,
    images: [
      "https://bookingenginecdn.hostaway.com/listing/116833-424944-sD08wL-uayAuTrkpLN8zKHpL0u2NPDfYlghXMjwJ6W4-68a5ea9e1dc88?width=1080&quality=70&format=webp&v=2",
      "https://bookingenginecdn.hostaway.com/listing/116833-424944-qHBRGn5p9AfD4uJrNGPPpbshDcpRQHKepnK00034lCg-68a5ea9cc48d9?width=640&quality=70&format=webp&v=2",
      "https://bookingenginecdn.hostaway.com/listing/116833-407457-659yQ--ZqqcZBMTLdlvgVfp1Q--oEl-ePp--1r8Nc75VlE-68606a80a90b6?width=640&quality=70&format=webp&v=2",
      "https://bookingenginecdn.hostaway.com/listing/116833-407457-6hAx-lBY5ADrSQtp82-1ARBHew7z3STr4hkzyfpdrSw-685ff905bc774?width=640&quality=70&format=webp&v=2",
    
    ],
    bedrooms: 1,
    bathrooms: 1,
    guests: 2,
    amenities: ["WiFi", "Air Conditioning"],
    type: "Studio",
    description:
      "A neat and affordable studio apartment perfect for short stays and business travelers.",
  },

  {
    id: 6,
    title: "Classic 3 Bedroom Terraced Duplex",
    location: "Surulere, Lagos",
    price: 90000,
    rating: 4.6,
    images: [
      "https://bookingenginecdn.hostaway.com/listing/116833-407457-659yQ--ZqqcZBMTLdlvgVfp1Q--oEl-ePp--1r8Nc75VlE-68606a80a90b6?width=640&quality=70&format=webp&v=2",
      "https://bookingenginecdn.hostaway.com/listing/116833-407457-6hAx-lBY5ADrSQtp82-1ARBHew7z3STr4hkzyfpdrSw-685ff905bc774?width=640&quality=70&format=webp&v=2",
    ],
    bedrooms: 3,
    bathrooms: 3,
    guests: 6,
    amenities: ["Parking", "Kitchen", "Air Conditioning"],
    type: "Duplex",
    description:
      "A classy home with spacious interiors, modern furnishing, and easy access to major roads.",
  },

  {
    id: 7,
    title: "Beachfront Luxury Villa",
    location: "Oniru Private Beach, Lagos",
    price: 500000,
    rating: 5.0,
    images: [
      "https://bookingenginecdn.hostaway.com/listing/116833-424944-sD08wL-uayAuTrkpLN8zKHpL0u2NPDfYlghXMjwJ6W4-68a5ea9e1dc88?width=1080&quality=70&format=webp&v=2",
      "https://bookingenginecdn.hostaway.com/listing/116833-424944-qHBRGn5p9AfD4uJrNGPPpbshDcpRQHKepnK00034lCg-68a5ea9cc48d9?width=640&quality=70&format=webp&v=2",
      "https://bookingenginecdn.hostaway.com/listing/116833-407457-659yQ--ZqqcZBMTLdlvgVfp1Q--oEl-ePp--1r8Nc75VlE-68606a80a90b6?width=640&quality=70&format=webp&v=2",
      "https://bookingenginecdn.hostaway.com/listing/116833-407457-6hAx-lBY5ADrSQtp82-1ARBHew7z3STr4hkzyfpdrSw-685ff905bc774?width=640&quality=70&format=webp&v=2",
    ],
    bedrooms: 5,
    bathrooms: 6,
    guests: 12,
    amenities: ["Beach Access", "Private Pool", "Chef", "WiFi"],
    type: "Villa",
    description:
      "A magnificent beachfront villa offering unmatched luxury, privacy, and direct beach access.",
  },

  {
    id: 8,
    title: "Affordable Mini Flat",
    location: "Ajah, Lagos",
    price: 40000,
    rating: 4.3,
    images: [
      "https://bookingenginecdn.hostaway.com/listing/116833-407457-659yQ--ZqqcZBMTLdlvgVfp1Q--oEl-ePp--1r8Nc75VlE-68606a80a90b6?width=640&quality=70&format=webp&v=2",
      "https://bookingenginecdn.hostaway.com/listing/116833-407457-6hAx-lBY5ADrSQtp82-1ARBHew7z3STr4hkzyfpdrSw-685ff905bc774?width=640&quality=70&format=webp&v=2",
    ],
    bedrooms: 1,
    bathrooms: 1,
    guests: 2,
    amenities: ["Kitchenette", "Parking"],
    type: "Mini Flat",
    description:
      "A clean and budget-friendly mini flat suitable for individuals and couples.",
  },

  {
    id: 9,
    title: "Luxury 2 Bedroom Oceanfront Apartment",
    location: "Eko Atlantic City, Lagos",
    price: 300000,
    rating: 4.9,
    images: [
      "https://bookingenginecdn.hostaway.com/listing/116833-416462-wJIZTyCA5EPoYWyiar3qmSiuZ--qHzK6SB-R4pVqIUlc-688b4d75c357f?width=1080&quality=70&format=webp&v=2",
      "https://bookingenginecdn.hostaway.com/listing/116833-416462-Xmj05d-2mGk8kjdleFdZ8aGABFOiNv2HjpvUoVfkDi4-688b546fdc2fb?width=640&quality=70&format=webp&v=2",
      "https://bookingenginecdn.hostaway.com/listing/116833-409723---W5g8nYqflEsGIJDFt7v49Ha7kLQOW0QKOiWPJyZG4A-68686b921abfc?width=640&quality=70&format=webp&v=2",
      "https://bookingenginecdn.hostaway.com/listing/116833-416462-R2XN3tQ3S4M---iupD2seC4Qu2rX--Nov8j3T6Zl1YYpw-688b4d71d738c?width=640&quality=70&format=webp&v=2",
    ],
    bedrooms: 2,
    bathrooms: 2,
    guests: 4,
    amenities: ["Ocean View", "Air Conditioning", "Elevator Access"],
    type: "Apartment",
    description:
      "A premium high-rise apartment with stunning ocean views located in the prestigious Eko Atlantic.",
  },

  {
    id: 10,
    title: "Private 4 Bedroom Family Home",
    location: "Magodo Phase 2, Lagos",
    price: 120000,
    rating: 4.6,
    images: [
      "https://bookingenginecdn.hostaway.com/listing/116833-416462-wJIZTyCA5EPoYWyiar3qmSiuZ--qHzK6SB-R4pVqIUlc-688b4d75c357f?width=1080&quality=70&format=webp&v=2",
      "https://bookingenginecdn.hostaway.com/listing/116833-416462-Xmj05d-2mGk8kjdleFdZ8aGABFOiNv2HjpvUoVfkDi4-688b546fdc2fb?width=640&quality=70&format=webp&v=2",
      "https://bookingenginecdn.hostaway.com/listing/116833-409723---W5g8nYqflEsGIJDFt7v49Ha7kLQOW0QKOiWPJyZG4A-68686b921abfc?width=640&quality=70&format=webp&v=2",
      "https://bookingenginecdn.hostaway.com/listing/116833-416462-R2XN3tQ3S4M---iupD2seC4Qu2rX--Nov8j3T6Zl1YYpw-688b4d71d738c?width=640&quality=70&format=webp&v=2",
    ],
    bedrooms: 4,
    bathrooms: 4,
    guests: 8,
    amenities: ["Parking", "Kitchen", "Security"],
    type: "House",
    description:
      "A family-friendly home in a gated estate with top-notch security and modern amenities.",
  },

  {
    id: 11,
    title: "Modern Co-Living Apartment",
    location: "Ikeja GRA, Lagos",
    price: 45000,
    rating: 4.4,
    images: [
     "https://bookingenginecdn.hostaway.com/listing/116833-416462-wJIZTyCA5EPoYWyiar3qmSiuZ--qHzK6SB-R4pVqIUlc-688b4d75c357f?width=1080&quality=70&format=webp&v=2",
      "https://bookingenginecdn.hostaway.com/listing/116833-416462-Xmj05d-2mGk8kjdleFdZ8aGABFOiNv2HjpvUoVfkDi4-688b546fdc2fb?width=640&quality=70&format=webp&v=2",
      "https://bookingenginecdn.hostaway.com/listing/116833-409723---W5g8nYqflEsGIJDFt7v49Ha7kLQOW0QKOiWPJyZG4A-68686b921abfc?width=640&quality=70&format=webp&v=2",
      "https://bookingenginecdn.hostaway.com/listing/116833-416462-R2XN3tQ3S4M---iupD2seC4Qu2rX--Nov8j3T6Zl1YYpw-688b4d71d738c?width=640&quality=70&format=webp&v=2",
    ],
    bedrooms: 1,
    bathrooms: 1,
    guests: 1,
    amenities: ["WiFi", "Shared Kitchen", "Work Desk"],
    type: "Co-Living",
    description:
      "A serviced co-living apartment ideal for digital nomads and students.",
  },

  {
    id: 12,
    title: "Luxury Shortlet With Rooftop Lounge",
    location: "Osapa London, Lekki",
    price: 160000,
    rating: 4.8,
    images: [
      "https://bookingenginecdn.hostaway.com/listing/116833-416462-wJIZTyCA5EPoYWyiar3qmSiuZ--qHzK6SB-R4pVqIUlc-688b4d75c357f?width=1080&quality=70&format=webp&v=2",
      "https://bookingenginecdn.hostaway.com/listing/116833-416462-Xmj05d-2mGk8kjdleFdZ8aGABFOiNv2HjpvUoVfkDi4-688b546fdc2fb?width=640&quality=70&format=webp&v=2",
      "https://bookingenginecdn.hostaway.com/listing/116833-409723---W5g8nYqflEsGIJDFt7v49Ha7kLQOW0QKOiWPJyZG4A-68686b921abfc?width=640&quality=70&format=webp&v=2",
      "https://bookingenginecdn.hostaway.com/listing/116833-416462-R2XN3tQ3S4M---iupD2seC4Qu2rX--Nov8j3T6Zl1YYpw-688b4d71d738c?width=640&quality=70&format=webp&v=2",
    ],
    bedrooms: 3,
    bathrooms: 3,
    guests: 6,
    amenities: ["Rooftop Lounge", "WiFi", "Air Conditioning"],
    type: "Apartment",
    description:
      "A stylish shortlet with a modern rooftop lounge perfect for events and relaxation.",
  },

  {
    id: 13,
    title: "Penthouse Studio With City View",
    location: "Ikeja, Lagos",
    price: 70000,
    rating: 4.5,
    images: [
      "https://bookingenginecdn.hostaway.com/listing/116833-416462-wJIZTyCA5EPoYWyiar3qmSiuZ--qHzK6SB-R4pVqIUlc-688b4d75c357f?width=1080&quality=70&format=webp&v=2",
      "https://bookingenginecdn.hostaway.com/listing/116833-416462-Xmj05d-2mGk8kjdleFdZ8aGABFOiNv2HjpvUoVfkDi4-688b546fdc2fb?width=640&quality=70&format=webp&v=2",
      "https://bookingenginecdn.hostaway.com/listing/116833-409723---W5g8nYqflEsGIJDFt7v49Ha7kLQOW0QKOiWPJyZG4A-68686b921abfc?width=640&quality=70&format=webp&v=2",
      "https://bookingenginecdn.hostaway.com/listing/116833-416462-R2XN3tQ3S4M---iupD2seC4Qu2rX--Nov8j3T6Zl1YYpw-688b4d71d738c?width=640&quality=70&format=webp&v=2",
    ],
    bedrooms: 1,
    bathrooms: 1,
    guests: 2,
    amenities: ["City View", "WiFi", "Air Conditioning"],
    type: "Studio",
    description:
      "A beautiful studio located on the top floor with a stunning view of the city skyline.",
  },

  {
    id: 14,
    title: "Serene 2 Bedroom Garden Apartment",
    location: "Ogudu GRA, Lagos",
    price: 95000,
    rating: 4.3,
    images: [
      "https://bookingenginecdn.hostaway.com/listing/116833-416462-wJIZTyCA5EPoYWyiar3qmSiuZ--qHzK6SB-R4pVqIUlc-688b4d75c357f?width=1080&quality=70&format=webp&v=2",
      "https://bookingenginecdn.hostaway.com/listing/116833-416462-Xmj05d-2mGk8kjdleFdZ8aGABFOiNv2HjpvUoVfkDi4-688b546fdc2fb?width=640&quality=70&format=webp&v=2",
      "https://bookingenginecdn.hostaway.com/listing/116833-409723---W5g8nYqflEsGIJDFt7v49Ha7kLQOW0QKOiWPJyZG4A-68686b921abfc?width=640&quality=70&format=webp&v=2",
      "https://bookingenginecdn.hostaway.com/listing/116833-416462-R2XN3tQ3S4M---iupD2seC4Qu2rX--Nov8j3T6Zl1YYpw-688b4d71d738c?width=640&quality=70&format=webp&v=2",
    ],
    bedrooms: 2,
    bathrooms: 2,
    guests: 4,
    amenities: ["Garden", "Parking", "WiFi"],
    type: "Apartment",
    description:
      "A peaceful home with a green environment ideal for families and couples.",
  },

  {
    id: 15,
    title: "Executive Serviced Apartment",
    location: "Allen Avenue, Ikeja",
    price: 110000,
    rating: 4.7,
    images: [
      "https://bookingenginecdn.hostaway.com/listing/116833-416462-wJIZTyCA5EPoYWyiar3qmSiuZ--qHzK6SB-R4pVqIUlc-688b4d75c357f?width=1080&quality=70&format=webp&v=2",
      "https://bookingenginecdn.hostaway.com/listing/116833-416462-Xmj05d-2mGk8kjdleFdZ8aGABFOiNv2HjpvUoVfkDi4-688b546fdc2fb?width=640&quality=70&format=webp&v=2",
      "https://bookingenginecdn.hostaway.com/listing/116833-409723---W5g8nYqflEsGIJDFt7v49Ha7kLQOW0QKOiWPJyZG4A-68686b921abfc?width=640&quality=70&format=webp&v=2",
      "https://bookingenginecdn.hostaway.com/listing/116833-416462-R2XN3tQ3S4M---iupD2seC4Qu2rX--Nov8j3T6Zl1YYpw-688b4d71d738c?width=640&quality=70&format=webp&v=2",
    ],
    bedrooms: 2,
    bathrooms: 2,
    guests: 4,
    amenities: ["Gym", "WiFi", "Generator"],
    type: "Serviced Apartment",
    description:
      "An executive serviced apartment with uninterrupted power and premium furnishing.",
  },
  {
    id: 16,
    priceTag: "Best Offer",
    title: "Luxury 3 Bedroom Sea View Apartment",
    location: "Lekki Phase 1, Lagos",
    price: 250000,
    rating: 4.9,
    images: [
      "https://bookingenginecdn.hostaway.com/listing/116833-416462-wJIZTyCA5EPoYWyiar3qmSiuZ--qHzK6SB-R4pVqIUlc-688b4d75c357f?width=1080&quality=70&format=webp&v=2",
      "https://bookingenginecdn.hostaway.com/listing/116833-416462-Xmj05d-2mGk8kjdleFdZ8aGABFOiNv2HjpvUoVfkDi4-688b546fdc2fb?width=640&quality=70&format=webp&v=2",
      "https://bookingenginecdn.hostaway.com/listing/116833-409723---W5g8nYqflEsGIJDFt7v49Ha7kLQOW0QKOiWPJyZG4A-68686b921abfc?width=640&quality=70&format=webp&v=2",
      "https://bookingenginecdn.hostaway.com/listing/116833-416462-R2XN3tQ3S4M---iupD2seC4Qu2rX--Nov8j3T6Zl1YYpw-688b4d71d738c?width=640&quality=70&format=webp&v=2",
    ],
    bedrooms: 3,
    bathrooms: 3,
    guests: 6,
    amenities: ["Pool", "WiFi", "Air Conditioning", "Kitchen"],
    type: "Apartment",
    description:
      "Experience luxury living in this stunning 3-bedroom apartment with panoramic ocean views, modern finishing, and premium amenities.",
  },
];
